import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Element } from '../../../../../common/html/element'
import { COMPONENTS } from '../../../../../routers/constants'
import classes from '../../../../index.module.scss'

export const ChoosePackageList = () => {
  return (
    <div
      className={[classes.fieldRow, 'flexRow justifyContentBetween'].join(' ')}
    >
      <Element style={{ fontSize: 14 }} className="fw600">
        <Translate value="userManagement.buyPackage.CHOOSE_YOUR_PACKAGE" />
      </Element>

      <Link
        to={
          COMPONENTS.userManagement.components.subscriptionPayment.components
            .packageList.route
        }
        target="_blank"
      >
        <Translate
          value="userManagement.buyPackage.PACKAGE_LIST"
          style={{ color: '#2C73E8' }}
        />
      </Link>
    </div>
  )
}
